import { useMutation, useQueryClient } from '@tanstack/react-query';

import { SEARCH_USERS_QUERY_KEY } from './useSearchUsers';

import UserService, { CreateUserDto } from '@/services/UserService';

export function useCreateUser() {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (createUserDto: CreateUserDto) =>
      UserService.createUser(createUserDto),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: SEARCH_USERS_QUERY_KEY });
    },
  });

  return {
    createUser: mutateAsync,
    isLoading: isPending,
  };
}
